import dayjs from 'dayjs'

export const TOKEN = 'token'

export const SUPPORTED_LANGUAGES = ['en']
export const DEFAULT_LANGUAGE = 'en'

export const DEFAULT_ANIMATION = 'ease-in 400ms'

export const SCREEN_BLOCKER_QUERY = '(max-width: 990px)'

export const ACCEPTED_IMAGE_TYPES = 'image/png, image/jpg, image/jpeg'

export const DATE_FORMAT = {
  monthDayYear: 'MM/DD/YY ',
  full: 'MMMM D, YYYY h:mm A',
  filter: 'YYYY-MM-DD',
}

export const QUERYSTRING_PARSE_FORMAT = {
  arrayFormat: 'bracket',
  skipNull: true,
  skipEmptyString: true,
}
export const DEFAULT_DEBOUNCE = 300

export const usStates = [
  { name: 'ALABAMA', abbreviation: 'AL' },
  { name: 'ALASKA', abbreviation: 'AK' },
  { name: 'AMERICAN SAMOA', abbreviation: 'AS' },
  { name: 'ARIZONA', abbreviation: 'AZ' },
  { name: 'ARKANSAS', abbreviation: 'AR' },
  { name: 'CALIFORNIA', abbreviation: 'CA' },
  { name: 'COLORADO', abbreviation: 'CO' },
  { name: 'CONNECTICUT', abbreviation: 'CT' },
  { name: 'DELAWARE', abbreviation: 'DE' },
  { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
  { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
  { name: 'FLORIDA', abbreviation: 'FL' },
  { name: 'GEORGIA', abbreviation: 'GA' },
  { name: 'GUAM', abbreviation: 'GU' },
  { name: 'HAWAII', abbreviation: 'HI' },
  { name: 'IDAHO', abbreviation: 'ID' },
  { name: 'ILLINOIS', abbreviation: 'IL' },
  { name: 'INDIANA', abbreviation: 'IN' },
  { name: 'IOWA', abbreviation: 'IA' },
  { name: 'KANSAS', abbreviation: 'KS' },
  { name: 'KENTUCKY', abbreviation: 'KY' },
  { name: 'LOUISIANA', abbreviation: 'LA' },
  { name: 'MAINE', abbreviation: 'ME' },
  { name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
  { name: 'MARYLAND', abbreviation: 'MD' },
  { name: 'MASSACHUSETTS', abbreviation: 'MA' },
  { name: 'MICHIGAN', abbreviation: 'MI' },
  { name: 'MINNESOTA', abbreviation: 'MN' },
  { name: 'MISSISSIPPI', abbreviation: 'MS' },
  { name: 'MISSOURI', abbreviation: 'MO' },
  { name: 'MONTANA', abbreviation: 'MT' },
  { name: 'NEBRASKA', abbreviation: 'NE' },
  { name: 'NEVADA', abbreviation: 'NV' },
  { name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
  { name: 'NEW JERSEY', abbreviation: 'NJ' },
  { name: 'NEW MEXICO', abbreviation: 'NM' },
  { name: 'NEW YORK', abbreviation: 'NY' },
  { name: 'NORTH CAROLINA', abbreviation: 'NC' },
  { name: 'NORTH DAKOTA', abbreviation: 'ND' },
  { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP' },
  { name: 'OHIO', abbreviation: 'OH' },
  { name: 'OKLAHOMA', abbreviation: 'OK' },
  { name: 'OREGON', abbreviation: 'OR' },
  { name: 'PALAU', abbreviation: 'PW' },
  { name: 'PENNSYLVANIA', abbreviation: 'PA' },
  { name: 'PUERTO RICO', abbreviation: 'PR' },
  { name: 'RHODE ISLAND', abbreviation: 'RI' },
  { name: 'SOUTH CAROLINA', abbreviation: 'SC' },
  { name: 'SOUTH DAKOTA', abbreviation: 'SD' },
  { name: 'TENNESSEE', abbreviation: 'TN' },
  { name: 'TEXAS', abbreviation: 'TX' },
  { name: 'UTAH', abbreviation: 'UT' },
  { name: 'VERMONT', abbreviation: 'VT' },
  { name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
  { name: 'VIRGINIA', abbreviation: 'VA' },
  { name: 'WASHINGTON', abbreviation: 'WA' },
  { name: 'WEST VIRGINIA', abbreviation: 'WV' },
  { name: 'WISCONSIN', abbreviation: 'WI' },
  { name: 'WYOMING', abbreviation: 'WY' },
]

export const LAB_ORDER_ATTRIBUTES = {
  shippingAddressId: 'shipping_address_id',
  localPickup: 'local_pickup',
  selectedCardToUse: 'selected_card_to_use',
  discountCode: 'discount_code',
  boutiqueShipping: 'boutique_shipping',
  orderNotes: 'order_notes',
}

export const LAB_ORDER_STATUS = {
  open: { label: 'Open' },
  paid: { label: 'Paid' },
  printing: { label: 'Printing' },
  framing: { label: 'Framing' },
  cancelled: { label: 'Canceled' },
  shipped: { label: 'Shipped' },
  reprint: { label: 'Reprinting' },
  in_production: { label: 'In Production' },
  on_hold: { label: 'On Hold' },
}

export const LINE_ITEM_STATUS = {
  open: { label: 'Open' },
  paid: { label: 'Paid' },
  printing: { label: 'Printing' },
  framing: { label: 'Framing' },
  cancelled: { label: 'Canceled' },
  shipped: { label: 'Shipped' },
  reprint: { label: 'Reprinting' },
  in_production: { label: 'In Production' },
  on_hold: { label: 'On Hold' },
}

export const LAB_ORDER_NOTES = {
  urgent: 'urgent',
  adminNote: 'admin_notes',
  orderNote: 'order_notes',
}

export const USER_STATUS = {
  approved: 'approved',
  declined: 'declined',
  pending: 'pending',
}

export const TODAY = dayjs().format(DATE_FORMAT.filter)
export const YESTERDAY = dayjs().subtract(1, 'days').format(DATE_FORMAT.filter)
export const THIS_WEEK = dayjs().subtract(7, 'days').format(DATE_FORMAT.filter)
export const LAST_30_DAYS = dayjs().subtract(30, 'days').format(DATE_FORMAT.filter)
export const LAST_3_MONTHS = dayjs().subtract(3, 'months').format(DATE_FORMAT.filter)

export const DATE_FILTERS = {
  today: { label: 'Today', startDate: TODAY, endDate: TODAY },
  yesterday: { label: 'Yesterday', startDate: YESTERDAY, endDate: YESTERDAY },
  thisWeek: { label: 'This Week', startDate: THIS_WEEK, endDate: TODAY },
  last30Days: { label: 'Last 30 days', startDate: LAST_30_DAYS, endDate: TODAY },
  last3Months: { label: 'Last 3 Months', startDate: LAST_3_MONTHS, endDate: TODAY },
}

export const PAPER_TYPES = {
  lustre: { label: 'Lustre', abbreviation: 'L' },
  // sating: { label: 'Satin', abbreviation: 'S' },
  photo_rag_baryta: { label: 'Baryta', abbreviation: 'B' },
  bamboo: { label: 'Bamboo', abbreviation: 'BA' },
  hemp: { label: 'Hemp', abbreviation: 'H' },
  smooth_matte: { label: 'Smooth Matte', abbreviation: 'SM' },
  // photo_matte: { label: 'Photo Matte', abbreviation: 'PM' },
  ultra_smooth: { label: 'Ultra Smooth', abbreviation: 'US' },
  platine: { label: 'Platine', value: 'platine', abbreviation: 'PT' },
  canson_rag: { label: 'Canson Rag', abbreviation: 'CR' },
  museum_etching: { label: 'Museum Etching', abbreviation: 'ME' },
  deckled: { label: 'Deckled', abbreviation: 'DKL' },
  canvas: { label: 'Canvas', abbreviation: 'CNV' },
  satin: { label: 'Satin', abbreviation: 'SA' }
}

const paperTypes = Object.values(PAPER_TYPES)

export const getPaperType = (value) => {
  const paperName = (value ?? '').toLowerCase().replaceAll('_', ' ')
  return paperTypes.find((paper) => paperName.includes(paper.label.toLowerCase()))
}


export const FILTER_COLORS = {

  ...Object.fromEntries(
    Object.values(PAPER_TYPES).map(paper => [paper.label, 'paper-color'])
  ),

  'Matting': 'matting-color',
  'Mounting': 'mounting-color',
  'Framing': 'framing-color',
  'Canvas': 'canvas-color',
  'API Orders': 'api-orders-color',
  'Test Prints': 'test-prints-color',
  'Boutique': 'boutique-color',
  'Artist Proofs': 'artist-proof-color'

};

export const SERVICE_TYPES = {
  prints: { label: 'Prints', abbreviation: 'PRT', iconClassname: 'prints' },
  mat: { label: 'Matting', abbreviation: 'MAT', iconClassname: 'matting' },
  mount: { label: 'Mounting', abbreviation: 'MNT', iconClassname: 'mounting' },
  frame: { label: 'Framing', abbreviation: 'FRM', iconClassname: 'framing' },
  canvas: { label: 'Canvas', abbreviation: 'CNV', iconClassname: 'canvas' },
  api_order: { label: 'API Orders', abbreviation: 'API', iconClassname: 'api' },
  test_print: {
    label: 'Test Prints',

    abbreviation: 'TP',
    iconClassname: 'test-prints',
  },
  boutique: {
    label: 'Boutique',

    abbreviation: 'BTQ',
    iconClassname: 'boutique',
  },
  artist_proof: {
    label: 'Artist Proofs',
    abbreviation: 'AP',
    iconClassname: 'calibration',
  },
  albums: { label: 'Albums', abbreviation: 'ALB', iconClassname: 'albums' },
  multi_openings: { label: 'Multi Opening', abbreviation: 'MO', iconClassname: 'multi-openings' },
}

const serviceTypesByLabel = Object.fromEntries(
  Object.values(SERVICE_TYPES).map((service) => [service.label.toLowerCase(), service]),
)

export const getServiceType = (value) => SERVICE_TYPES[value]
  || SERVICE_TYPES[`${value}s`]
  || serviceTypesByLabel[value?.toLowerCase()]

export const getLineItemServiceType = (lineItem, isMultiOpening) => {
  const category = lineItem?.finishingCategoryName || lineItem?.finishingService?.finishingCategory || ''
  return getServiceType(lineItem?.finishingCategoryName)
    || (/\bfram(?:e[ds]?|ing)?\b/i.test(category) ? SERVICE_TYPES.frame : undefined)
    || (isMultiOpening && /\bmat(?:ting)?\b/i.test(category) ? SERVICE_TYPES.mat : undefined)
}

export const PaperAbbreviation = {
  'Lustre': 'L',
  'Baryta': 'B',
  'Bamboo': 'BA',
  'Ultra Smooth': 'US',
  'Platine': 'PT',
  'Canson Rag': 'CR',
  'Museum Etching': 'ME',
  'Deckled': 'DKL',
  'Satin': 'SA'
};

export const PaperTypes = [
  { label: 'Lustre', code: 'L' },
  { label: 'Baryta', code: 'B' },
  { label: 'Bamboo', code: 'BA' },
  { label: 'Hemp', code: 'H' },
  { label: 'Smooth Matte', code: 'SM' },
  { label: 'Satin', code: 'SA' },
  { label: 'Ultra Smooth', code: 'US' },
  { label: 'Platine', code: 'PT' },
  { label: 'Canson Rag', code: 'CR' },
  { label: 'Museum Etching', code: 'ME' },
  { label: 'Deckled', code: 'DKL' },
  { label: 'Canvas', code: 'CNV' }
]

export const Services = [
  { label: 'Matting', code: 'MAT', value: 'mat', className: 'matting' },
  { label: 'Mounting', code: 'MNT', value: 'mount', className: 'mounting' },
  { label: 'Framing', code: 'FRM', value: 'frame', className: 'framing' },
  { label: 'Canvas', code: 'CNV', value: 'canvas', className: 'canvas' },
  { label: 'API Orders', code: 'API', value: 'api', className: 'api' },
  { label: 'Test Prints', code: 'TP', value: 'test_print', className: 'test-prints' },
  { label: 'Boutique', code: 'BTQ', value: 'boutique', className: 'boutique' },
  { label: 'Artist Proofs', code: 'AP', value: 'artist_proof', className: 'calibration' },
  { label: 'Albums', code: 'ALB', value: 'album', className: 'album' },
  { label: 'Multi Opening', code: 'MO', value: 'multi-opening', className: 'multi-opening' },
]


export const ORDER_BY = {
  'a-z_asc': { label: 'Ascending (A-Z)' },
  'a-z_desc': { label: 'Descending (Z-A)' },
  paid_at_desc: { label: 'Newest to Oldest' },
  paid_at_asc: { label: 'Oldest to Newest' },
}

export const SHIPPING_METHODS = {
  twoDay: 'two_day',
  overnight: 'overnight',
}

export const SIGN_UP_STEPS = {
  registration: 1,
  referral: 2,
  resaleCertificate: 3,
}

export const PROFILE_RULES = {
  firstName: {
    required: {
      value: true,
      message: 'Please enter your first name.',
    },
  },
  lastName: {
    required: {
      value: true,
      message: 'Please enter your last name.',
    },
  },
  email: {
    required: {
      value: true,
      message: 'Please enter your email.',
    },
  },
  phone: {
    required: {
      value: true,
      message: 'Please enter your phone number.',
    },
  },
  businessUrl: {
    required: {
      value: true,
      message: 'Please enter your Website or Social Media URL.',
    },
  },
  password: {
    required: { value: true, message: 'Password is required' },
  },
  confirmPassword: {
    required: { value: true, message: 'Password is required' },
  },
  businessName: {
    required: { value: false },
  },
}

export const paperListOrder = [
  'Museum Etching',
  'Canson Rag',
  'Photo Rag Baryta',
  'Ultra Smooth',
  'Platine',
  'Bamboo',
  'Lustre',
  'Deckled Paper - no border',
  'Deckled Paper - with border',
  'Circle Deckle - no border',
  'Circle Deckle - with border',
  'Brushed Canvas',
  'Canvas - Mirror Wrap - 1.5 inch Bar',
  'Canvas - Gallery Wrap - 1.5 inch Bar',
  'Canvas - White Wrap - 1.5 inch Bar',
  'Canvas - Black Wrap - 1.5 inch Bar',
  'Canvas - White Wrap - 0.75 inch Bar'
];

export const normalizePaperName = (name) => {
  if (name === 'Canvas - White Wrap - 0.5 inch Bar') {
    return 'Canvas - White Wrap - 0.75 inch Bar';
  }
  if (name === 'Deckled Paper - Circle no border') {
    return 'Circle Deckle - no border';
  }
  if (name === 'Deckled Paper - Circle with border') {
    return 'Circle Deckle - with border';
  }
  if (name === 'Deckled Paper - Oval no border') {
    return 'Oval Deckle - no border';
  }
  if (name === 'Deckled Paper - Oval with border') {
    return 'Oval Deckle - with border';
  }
  return name;
};

export const PRODUCT_TYPE_OPTIONS = [
  // { value: 'default', text: 'Choose One' },
  { value: 'prints', text: 'Prints' },
  { value: 'albums', text: 'Albums' },
  { value: 'framed-prints', text: 'Framed Prints' },
  { value: 'multi-opening', text: 'Multi-Opening' },
  { value: 'circle-oval', text: 'Circle & Oval Frames' },
  { value: 'matted-prints', text: 'Matted Prints' },
  { value: 'mounted-prints', text: 'Mounted Prints' },
  { value: 'canvas', text: 'Canvas' },
  { value: 'test-prints', text: 'Test Prints' },
  { value: 'artist-proofs', text: 'Artist Proof' },
]

export const SPREAD_CONSTANTS = {
  MIN_SPREADS: 10,
  DEFAULT_MAX_SPREADS: 35,
  HEMP_MAX_SPREADS: 25,
};

export const CLAMSHELL_TRAY_COVER_FABRIC_NAMES = [
  'Agave',
  'Amethyst',
  'Aquamarine',
  'Bronze',
  'Brunette',
  'Butterscotch',
  'Castleton',
  'Celadon',
  'Dijon',
  'Eggplant',
  'Fern',
  'Fawn',
  'Garnet',
  'Heather',
  'Indigo',
  'Laurel',
  'Olive',
  'Peacock',
  'Pewter',
  'Silver',
  'Turquoise',
  'Wafer',
  'Willowbrook'
];

export const COMING_SOON_ALBUM_TYPES = ['museum-case', 'double-folio'];
export const MUSEUM_CASE_ORDER_HERE_URL = 'https://www.musealab.com/museumcase';
export const DOUBLE_FOLIO_ORDER_HERE_URL = 'https://www.musealab.com/doublefolio';
